import { RootState } from "../index";
import { createEntityAdapter, createSlice, EntityId } from '@reduxjs/toolkit';
import { destroyReport, fetchReport, fetchReports, updateReport } from "../../actions/roblox/reportsActions";

export interface ReportInterface {
  id: number;

  closed: boolean;
  reason_id: number;
  reason_text: string;
  reason: string;

  target_id: number;
  target_type: string;

  created_at: string;
  updated_at: string;

  user_id: EntityId;
  active_user_id: EntityId;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;

  editId: EntityId | null;
  editError: string | null;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,

  editId: null,
  editError: null,
};

const reportsAdapter = createEntityAdapter<ReportInterface>();

const slice = createSlice({
  name: 'reports',
  initialState: reportsAdapter.getInitialState(initialState),
  reducers: {
    setEditId: (state, action) => {
      state.editId    = action.payload;
      state.editError = initialState.editError;
    },
    setEditError: (state, action) => {
      state.editError = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchReports.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.reports;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchReports.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchReport.fulfilled, (state, action) => {
        const report = Object.values(action.payload.report)[0];
        state.entities[report.id] = report;
      })

      // #update
      .addCase(updateReport.fulfilled, (state, action) => {
        const report = Object.values(action.payload.report)[0];
        state.entities[report.id] = report;
      })
      .addCase(updateReport.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.editError = error || action.error.message || 'Unknown Error';
      })

      // #destroy
      .addCase(destroyReport.fulfilled, (state, action) => {
        reportsAdapter.removeOne(state, action.payload.id);
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  setEditId,
  setEditError
} = slice.actions;

export const {
  selectById: selectReportById,
  selectIds: selectReportIds,
  selectEntities: selectReportEntities,
  selectAll: selectAllReports,
} = reportsAdapter.getSelectors<RootState>(state => state.roblox.reports);
